/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import LayoutWrapper from "./LayoutWrapper";
import ReleaseNotes from "./ReleaseNotes";


const ReleaseScreen = (props) => {
    return (
        <LayoutWrapper model="domain" renderOpsBar={false}>

            <ReleaseNotes margin="auto"/>

        </LayoutWrapper>
    );
};


export default ReleaseScreen;
